<template>
    <div
        class="flex flex-row items-center justify-end"
        v-if="casinoReviewsForSelect.length"
    >
        <Select
            class="col-span-2 -mt-1"
            name="casino_review"
            v-model.number="casinoReviewTemplate"
            placeholder="Casino Reviews"
            unsettable
            :options="casinoReviewsForSelect"
        >
        </Select>
        <Btn
            @click="duplicateFrom"
            class="col-span-3 ml-1"
            :class="{disabled: disabled}"
            type="button"
            content="Duplicate from Selected"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import siteLanguage from '../../config/siteLanguage'

export default {
    name: "DuplicateFromCasinoReview",
    props: {
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
    },
    data() {
        return {
            casinoReviewTemplate: null,
            casinoReviewsWithTables: [],
        };
    },
    mounted() {
        this.getDuplicatableCasinos();
    },
    methods: {
        async getDuplicatableCasinos() {
            const { data } = await axios
                .get(
                    route("api.casinoReviews.index", {
                        language: this.language.id,
                        languages: this.language.id,
                        where: [
                            {
                                column: "two_col_four_table",
                                operator: "!=",
                                value: null,
                            },
                        ],
                    })
                )
                .catch((err) => console.error(err.response.data || err));

            this.casinoReviewsWithTables = data.data;
        },
        async duplicateFrom() {
            const { data } = await axios
                .get(
                    route("api.casinoReviews.index", {
                        language: this.language.id,
                        languages: this.language.id,
                        where: {
                            column: "id",
                            value: this.casinoReviewTemplate,
                        },
                    })
                )
                .catch((err) => console.error(err.response.data || err));

            this.$emit("duplicated", data.data[0]);
        },
    },
    computed: {
        casinoReviewsForSelect() {
            return this.casinoReviewsWithTables.map((casinoReview) => {
                return {
                    value: casinoReview.id,
                    name: casinoReview.name,
                };
            });
        },
        disabled() {
            return this.casinoReviewTemplate === null;
        }
    },
};
</script>

<style></style>
